import React from 'react';

import {
  HomefieldIconSocialFacebook,
  HomefieldIconSocialInstagram,
  HomefieldIconSocialX,
  HomefieldIconSocialYoutube,
} from '@dsg-tech/homefield-react-icons';
import './MJFooterSocialLinks.scss';

export default function MJFooterSocialLinks() {
  return (
    <div
      data-testid="mj-footer-social-links"
      className="footerSocialLinks-container hmf-py-xl hmf-py-m-0">
      <a
        href="https://www.instagram.com/moosejawmadness"
        target="_blank"
        tabIndex={0}
        aria-label="follow us on instagram"
        rel="noreferrer">
        <HomefieldIconSocialInstagram className="hmf-pr-s" />
      </a>
      <a
        href="https://www.facebook.com/moosejaw"
        target="_blank"
        tabIndex={0}
        aria-label="follow us on facebook"
        rel="noreferrer">
        <HomefieldIconSocialFacebook className="hmf-pr-s" />
      </a>
      <a
        href="https://twitter.com/Moosejaw"
        target="_blank"
        tabIndex={0}
        aria-label="follow us on twitter"
        rel="noreferrer">
        <HomefieldIconSocialX className="hmf-pr-s" />
      </a>
      <a
        href="https://www.youtube.com/user/MoosejawMadness"
        target="_blank"
        tabIndex={0}
        aria-label="follow us on youtube"
        rel="noreferrer">
        <HomefieldIconSocialYoutube className="" />
      </a>
      <p className="footerSocialLinks-container__text hmf-body-l">
        <span>Follow us.</span> We’ll guide you.
      </p>
    </div>
  );
}
